import { shipmentApiClient } from '../shipmentApiClient'
import { updateShipmentVisitDeliveryEndpoint } from './endpoint'
import type {
  UpdateShipmentVisitDeliveryParams,
  UpdateShipmentVisitDeliveryRequest,
  UpdateShipmentVisitDeliveryResponse,
} from './type'

export const updateShipmentVisitDelivery = async (
  params: UpdateShipmentVisitDeliveryParams
): Promise<UpdateShipmentVisitDeliveryResponse> => {
  // 相互排他: 指定された側のキーのみ body に載せる。
  // 両方未指定なら認証フィールドのみ送り、BE が両カラムを NULL クリアする。
  const body: UpdateShipmentVisitDeliveryRequest = {
    delivery_report_uid: params.deliveryReportUid,
    driver_phone: params.driverPhone,
  }
  if (params.deliveryTenantId != null) {
    body.delivery_tenant_id = params.deliveryTenantId
  } else if (params.deliveryDestination != null) {
    body.delivery_destination = params.deliveryDestination
  }
  const res = await shipmentApiClient.patch<UpdateShipmentVisitDeliveryResponse>(
    updateShipmentVisitDeliveryEndpoint(params.shipmentUid, params.visitId),
    body
  )
  return res.data
}
